import type { ApiProblem } from '@rental/contracts/client'

/**
 * A failed call, thrown inside queries so React Query and the access gate can
 * see it. Its own module, so pure code (problems.ts) can tell it apart without
 * loading the API client, which reads the page's location when it loads.
 */
export class ProblemError extends Error {
  readonly problem: ApiProblem

  constructor(problem: ApiProblem) {
    super(problem.kind === 'network' ? 'network' : problem.code)
    this.name = 'ProblemError'
    this.problem = problem
  }
}
